/// <reference path='../typings/Easydropdown.d.ts' />
import easydropdown from 'easydropdown/dist/Easydropdown/Easydropdown.js';
const moduleSelector = '[data-module="Form"]';

export default class Form {

    input: HTMLInputElement[];
    parent: HTMLElement;
    textElement: HTMLElement;
    positiveValidation: HTMLElement;
    field: HTMLInputElement[];
    dropdownWidth: number;

    static setup(selector: string = moduleSelector): void {
        Array.from(document.querySelectorAll(selector)).filter((node: HTMLElement) => !node.dataset.moduleInitialized).forEach((element: HTMLElement) => {
            new Form(element);
            element.dataset.moduleInitialized = 'true';
        });
    }

    constructor(public element: HTMLElement) {
        this.setUp();
    }

    setUp() {
        this.input = Array.from(<NodeListOf<HTMLInputElement>>document.querySelectorAll('input'));
        this.parent = <HTMLElement>document.querySelector('form');
        this.textElement = <HTMLElement>document.querySelector('form .text');

        this.element.addEventListener('focusin', (event) => this.focusIn(event));

        this.element.addEventListener('input', (event) => {
            var target = <HTMLInputElement>event.target;
            (target.value) ? this.showValid(event) : "";
        });

        this.element.addEventListener('focusout', (event) => {
            this.focusOut(event);
        });

        Array.from(document.querySelectorAll('.alpaca-form select:not(.edd-select)')).forEach((element: HTMLSelectElement) => {
            new easydropdown(element, {
                behavior: {
                    useNativeUiOnMobile: false,
                    maxVisibleItems: 10

                },
                callbacks: {
                    onSelect: () => {
                        this.toggleDropdown(element, false);
                    }
                }
            });

        });

        Array.from(document.querySelectorAll('.droplist-wrapper:not(.initDropDown) .edd-head')).forEach((element: HTMLSelectElement) => {
            element.addEventListener('click', (event) => this.toggleDropdown(element, true));
            element.closest('.droplist-wrapper').classList.add('initDropDown');
        });

        document.addEventListener('click', (event) => this.closeDropdown(event));

        this.input.filter(i => i.value).forEach(i => i.closest('.field') && i.closest('.field').classList.add('focused'));
    }

    toggleDropdown(element, isToggle) {
        var currentTarget = <HTMLElement>element.closest('.edd-root'),
            target = <HTMLElement>currentTarget.parentNode;

        if (isToggle) {
            if (target.classList.contains('dropdown-open')) {
                target.classList.remove('dropdown-open');

            } else {
                Array.from(document.querySelectorAll('.droplist-wrapper, .datePicker-wrapper')).forEach((element: HTMLElement) => {
                    element.classList.remove('dropdown-open');
                });

                target.classList.add('dropdown-open');
            }

        } else {
            target.classList.remove('dropdown-open');
        }
    }

    focusIn(event: Event): void {
        var target = <HTMLInputElement>event.target;
        if (target.tagName !== 'BUTTON' && target.tagName !== 'A') {
            target.closest('.field').classList.add('focused');
        }
    }

    focusOut(event: Event): void {
        var target = <HTMLInputElement>event.target;
        if (target.tagName !== 'BUTTON' && target.tagName !== 'A') {
            (!target.value) ? target.closest('.field').classList.remove('focused') : '';
        }
    }

    showValid(event: Event) {
        var target = <HTMLInputElement>event.target,
            parent = target.closest('.field');

        if (!(parent.classList.contains('focused'))) {
            parent.classList.add('focused');
        }

    }

    closeDropdown(event) {
        var target = <HTMLInputElement>event.target; {
            if (!target.closest('.edd-root')) {
                Array.from(document.querySelectorAll('.droplist-wrapper, .datePicker-wrapper')).forEach((element: HTMLElement) => {
                    element.classList.remove('dropdown-open');
                });
            }
        }
    }
}

//new Form.setup();